import React, { useContext, useEffect, useState } from 'react'
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import useRequest from 'app/hooks/useRequest';
import UserContext from 'app/context/UserContext';
import { toast } from 'react-toastify';
import Divider from 'components/common/Divider';
import { GetContact, updateContactUs } from 'app/api/PublicOptionsService';
import axios from 'axios';
function ContactUsForm() {
  const { user } = useContext(UserContext);
  const { response, send, loading } = useRequest();

  const [investment, setInvestment] = useState({
    name: '...',
    email: '...',
    phone: '...',
  });

  const handleSubmit = e => {
    e.preventDefault();
    send(updateContactUs(user.token, investment));
  };

  function GetContactInfo() {
    const { url, method } = GetContact();

    axios({ url, method })
      .then(res => {
        setInvestment({
          name: res.data.data.name,
          email: res.data.data.email,
          phone: res.data.data.phone, 
        });
      })
      .catch(err => {
        console.error('Error fetching contact:', err);
      });
  }

  // Initial load + after update
  useEffect(() => {
    GetContactInfo();
  }, [response]);

  // ✅ Safe success toast
  useEffect(() => {
    if (response?.data?.message) {
      toast.success(response.data.message);
    }
  }, [response]);

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col xl={12}>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              value={investment.name}
              required
              onChange={e =>
                setInvestment({ ...investment, name: e.target.value })
              }
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              value={investment.email}
              onChange={e =>
                setInvestment({ ...investment, email: e.target.value })
              }
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Contact Number </Form.Label>
            <Form.Control
              type="text"
              value={investment.phone}
              onChange={e =>
                setInvestment({ ...investment, phone: e.target.value })
              }
            />
          </Form.Group>
        </Col>
      </Row>

      <Divider className="my-4" />

      <Button
        variant="primary"
        type="submit"
        disabled={loading}
      >
        {loading ? (
          <>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              className="me-2"
            />
            Saving...
          </>
        ) : (
          'Save'
        )}
      </Button>
    </Form>
  );
}
export default ContactUsForm